import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Text } from '@grandvisionhq/elements';
import Link from '../Link/Link.js';

var _id, _id1;
const LinkLists = (_param)=> {
    var { className , items  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "items"
    ]);
    return React.createElement("div", swcHelpers.extends({
        className: classnames('link-lists', className)
    }, rest), items.map((column, index1)=>/*#__PURE__*/ React.createElement("div", {
            className: "link-lists__column",
            key: (_id = column.id) !== null && _id !== void 0 ? _id : column.title || `item-${index1}`
        }, column.title && /*#__PURE__*/ React.createElement(Text, {
            className: "link-lists__text",
            component: "h2"
        }, column.title), column.links.map((link, index)=>/*#__PURE__*/ React.createElement(Link, swcHelpers.extends({
                key: (_id1 = link.id) !== null && _id1 !== void 0 ? _id1 : link.label || `column-item-${index}`,
                className: "link-lists__link"
            }, link))
        ))
    ));
};

export { LinkLists as default };
//# sourceMappingURL=LinkLists.js.map
